module.exports = __webpack_public_path__ + "static/media/arrow_discussion.bc54c78d.svg";